import React from 'react';
import { Node } from '@uncinc/react-drupal-core';
import { Fade } from 'react-awesome-reveal';


import {
  Container,
} from '../../../components';

import './style.scss';

const ContactPerson = ({ entity, containerless }) => {
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;

  return (
    containerless ? (
      <div id={paragraphKey} className="Paragraph ContactPerson">
        <Fade triggerOnce bottom distance="50px" duration={500}>
          <h2>{ entity.getIn(['field_title', 0, 'value']) }</h2>
          {
            entity.get('field_contact_persons').map((item) => {
              const entity = item.get('entity');
              return <Node key={item.get('target_id')} entity={entity} viewMode="card" />;
            })
          }
        </Fade>
      </div>
    ) : (
      <div id={paragraphKey} className="Paragraph ContactPerson">
        <Fade triggerOnce bottom distance="50px" duration={500}>
          <Container small>
            <h2>{ entity.getIn(['field_title', 0, 'value']) }</h2>
            {
              entity.get('field_contact_persons').map((item) => {
                const entity = item.get('entity');
                return <Node key={item.get('target_id')} entity={entity} viewMode="card" />;
              })
            }
          </Container>
        </Fade>
      </div>
    )
  );
};

export default ContactPerson;
